import { useTranslation } from 'react-i18next';

import { Paragraph } from '@app/shared/ui/atoms/Common';
import { TaskDialogMessageType } from '@app/shared/types/pages/tasks';

type Props = {
  messageType: TaskDialogMessageType | null;
  reward?: number;
};

export function TaskDialogMessage({ messageType, reward }: Props) {
  const { t } = useTranslation();

  const generateString = () => {
    if (messageType === 'reward' && reward !== undefined) {
      return t('tasks.success', { reward });
    }

    if (messageType === 'secret-room') {
      return t('tasks.secret_room');
    }

    if (messageType === 'help-ref' || messageType === 'help-name') {
      return t('tasks.telegram_settings', {
        value: t(messageType === 'help-name' ? 'common.name' : 'common.bio'),
      });
    }

    return '';
  };

  if (!messageType) {
    return null;
  }

  return (
    <Paragraph variant="white" size="lg" className="whitespace-pre-line">
      {generateString()}
    </Paragraph>
  );
}
